import { Typography, type TypographyProps, useTheme } from "@mui/material";

export const CoinTypography = (props: TypographyProps) => {
  const { colors } = useTheme();
  return (
    <Typography
      {...props}
      sx={{
        background: `linear-gradient(90deg, ${colors.text.brandPrimary} 0%, ${colors.text.rewardGold} 100%)`,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        ...props.sx,
      }}
    />
  );
};
